import { createSlice } from "@reduxjs/toolkit";

export const estimateFieldsNeedToRefreshIntialState = {
  takeoffs: [],
  measurements: false,
};

const estimateListSlice = createSlice({
  name: "estimateList",
  initialState: [],
  reducers: {
    getEstimateList: (_state, action) => action.payload,
    emptyEstimateList: () => [],
  },
});

const isEstimateExistSlice = createSlice({
  name: "isEstimateExist",
  initialState: true,
  reducers: {
    setIsEstimateExist: (_state, action) => action.payload,
  },
});

const estimateAdditionalCostSlice = createSlice({
  name: "estimateAdditionalCost",
  initialState: [],
  reducers: {
    setAdditionalCost: (_state, action) => action.payload,
  },
});

const additionalCostTotalSlice = createSlice({
  name: "additionalCostTotal",
  initialState: 0,
  reducers: {
    setEstimateAdditionalCostTotal: (_state, action) => action.payload,
  },
});

const dateVersionSlice = createSlice({
  name: "dateVersion",
  initialState: [],
  reducers: {
    getEstimateDateversion: (_state, action) => action.payload,
  },
});

const estimateDataSlice = createSlice({
  name: "estimateData",
  initialState: {},
  reducers: {
    setEstimateData: (_state, action) => action.payload,
  },
});

const estimateFieldsNeedToRefreshSlice = createSlice({
  name: "estimateFieldsNeedToRefresh",
  initialState: estimateFieldsNeedToRefreshIntialState,
  reducers: {
    setEstimateFieldsNeedtoRefresh: (_state, action) => action.payload,
  },
});

export const { getEstimateList, emptyEstimateList } = estimateListSlice.actions;
export const { setAdditionalCost } = estimateAdditionalCostSlice.actions;
export const { setEstimateAdditionalCostTotal } = additionalCostTotalSlice.actions;
export const { getEstimateDateversion } = dateVersionSlice.actions;
export const { setEstimateData } = estimateDataSlice.actions;
export const { setEstimateFieldsNeedtoRefresh } = estimateFieldsNeedToRefreshSlice.actions;
export const { setIsEstimateExist } = isEstimateExistSlice.actions;

export const estimateList: any = estimateListSlice.reducer;
export const getEstimateAdditionalCost: any = estimateAdditionalCostSlice.reducer;
export const additionalCostTotal: any = additionalCostTotalSlice.reducer;
export const getDateVersion: any = dateVersionSlice.reducer;
export const estimateData: any = estimateDataSlice.reducer;
export const estimateFieldsNeedToRefresh: any = estimateFieldsNeedToRefreshSlice.reducer;
export const isEstimateExistReducer: any = isEstimateExistSlice.reducer;

export default {
  estimateList,
  getEstimateAdditionalCost,
  additionalCostTotal,
  getDateVersion,
  estimateData,
  estimateFieldsNeedToRefresh,
  isEstimateExistReducer,
};
